import { getPrimeUrl } from "../utils/getPrimeUrl";

export interface ThirdMenuItemProps {
  title: string;
  key: string;
  to: string;
  tag?: string;
}

export interface SecondMenuItemProps {
  iconName?: string;
  key: string;
  title: string;
  description?: string;
  to?: string;
  items?: ThirdMenuItemProps[];
}

export interface FirstMenuItemProps {
  title: string;
  key: string;
  items: SecondMenuItemProps[];
}

export const getSharedMenuItems = ({
  quotationId,
}: {
  quotationId?: string;
}): FirstMenuItemProps[] => [
  {
    title: "상담/계약",
    key: "my",
    items: [
      {
        key: "quotation",
        title: "내 상담/견적 내역",
        to: quotationId
          ? `/match/recommendation/${quotationId}`
          : `/match/request/`,
      },
      {
        key: "contract",
        title: "내 계약서 확인",
        to: getPrimeUrl("/contract-check/?utm_campaign=gnb_drawer"),
      },
      {
        key: "product",
        title: "상품 가입하기",
        to: "/product",
      },
    ],
  },
  {
    title: "상품 안내",
    key: "product",
    items: [
      {
        iconName: "thumbnail_24",
        key: "product_list",
        title: "전체 상품 보기",
        to: "/product/",
      },
      {
        iconName: "gift_24",
        key: "product_packages",
        title: "고이 패키지",
        description: "모든 패키지 가입일부터 즉시 이용 가능",
        items: [
          {
            title: "무빈소장 159",
            key: "simple_funeral",
            to: "/service/무빈소장",
          },
          {
            title: "가족장 289",
            key: "family_funeral",
            to: "/service/가족장",
          },
          {
            title: "일반장 389",
            key: "general_funeral",
            to: "/service/일반장",
          },
          {
            title: "프리미엄 패키지",
            key: "premium_funeral",
            to: "/promotion/service/가족장/premium-2025/",
          },
        ],
      },
      {
        iconName: "payment_24",
        key: "product_by_payment",
        title: "납입 방식별",
        items: [
          {
            title: "고이 프라임",
            key: "goi_prime_products",
            to: "/product#product_monthly",
            tag: "월 납입 상품",
          },
          {
            title: "고이 퍼스트",
            key: "goi_first_products",
            to: "/product#product_downpayment",
            tag: "계약금 납입 상품",
          },
        ],
      },
      {
        iconName: "write_24",
        key: "review",
        title: "이용 후기",
        to: "/review/",
      },
    ],
  },
  {
    title: "장례 정보",
    key: "guidebook",
    items: [
      {
        iconName: "funeral_facility_24",
        key: "funeral_facilities",
        title: "장례시설 찾기",
        to: "/funeral-facilities/",
      },
      {
        iconName: "guidebook_24",
        key: "guidebook",
        title: "가이드북 전체",
        to: "/guidebook/",
      },
      {
        key: "guidebook_content",
        title: "장례 준비 처음부터 알아보기",
        items: [
          {
            title: "장례 준비의 시작",
            key: "funeral_prepare_1",
            to: "/funeral-prepare/1/",
          },
          {
            title: "장례식장 빈소 계약시 주의할 점",
            key: "guide_how_about_parlor_funeral",
            to: "/guide/how-about-parlor-funeral/",
          },
          {
            title: "상조 없이 장례를 치르려면?",
            key: "guide_about_parlor_funeral",
            to: "/guide/about-parlor-funeral/",
          },
          {
            title: "후불제 상조 알아보기",
            key: "funeral_prepare_2",
            to: "/funeral-prepare/2/",
          },
        ],
      },
      {
        iconName: "write_24",
        key: "review",
        title: "이용 후기",
        to: "/review/",
      },
    ],
  },
  {
    title: "읽을거리",
    key: "feed",
    items: [
      {
        key: "goi_feed",
        title: "고이 피드",
        to: getPrimeUrl("/content"),
      },
    ],
  },
  {
    title: "회사 소개",
    key: "company",
    items: [
      {
        key: "company_introduction",
        title: "고이장례연구소 소개",
        to: "/funeral-prepare/company-introduction/",
      },
      {
        key: "b2b",
        title: "기업 상조/제휴 문의",
        to: "https://partners.goifuneral.co.kr/?utm_campaign=platform/",
      },
    ],
  },
  {
    title: "고객 문의",
    key: "cs",
    items: [
      {
        key: "kakaotalk_chatting",
        title: "카카오톡 채팅 문의",
        to: "http://pf.kakao.com/_xgFDaK/chat",
      },
    ],
  },
];
